import React, {useState} from "react";
import {Button, Col, Container, Form, Row} from 'react-bootstrap'
import AuthService from '../services/AuthService';

const strings = require('../resources/strings.json');

export default function Login(props) {

    const INITIALSTATE = {
        email: "",
        password: ""
    }

    const [
        { email, password },
        setState
      ] = useState(INITIALSTATE);

    const validateForm = () => {
        return email.length > 0 && password.length > 0;
    }

    const handleChange = event => {
        const { name, value } = event.target;
        setState(prevState => ({ ...prevState, [name]: value }));
    };

    const handleSubmit = async event => {
        event.preventDefault();
        try {
            await AuthService.login(email, password);
            await AuthService.checkAuthorisation();
            props.userHasAuthenticated(true);
            props.history.push("/logs");
        } catch (e) {
            const message = getLoginErrorMessage(e)
            alert(message);
        }
    };

    const getLoginErrorMessage = (e) => {
        const errorStatusCode = e.response.status;
        if (errorStatusCode == 403) {
            return strings.forbiddenLoginMessage;
        }
        const errorDiscription = e.response.data.error_description;
        switch (errorDiscription) {
            case strings.badCredentials: return strings.badCredentialsMessage;
            case strings.accountLocked: return strings.accountLockedMessage;
            default: return strings.deafaultLoginErrorMessage;
        }
    }

    return (
        <Container>
            <Row style={{marginTop: 40}}>
                <Col sm={8}></Col>
                <Col sm={4}>
                    <Form onSubmit={handleSubmit}>
                        <Form.Group controlId="email" bssize="large">
                            <Form.Control type="email"
                                            name="email"
                                            onChange={handleChange}
                                            autoFocus
                                            value={email}/>
                        </Form.Group>
                        <Form.Group controlId="password" bssize="large">
                            <Form.Control
                                style={{marginTop: 16}}
                                name="password"
                                value={password}
                                onChange={handleChange}
                                type="password"
                            />
                        </Form.Group>
                        <Button
                            style={{marginTop: 16}}
                            block
                            bssize="large"
                            disabled={!validateForm()}
                            type="submit"
                        >
                            Login
                        </Button>
                    </Form>
                </Col>
            </Row>
        </Container>
    );   
}
